/*

renders the mediastream to a hidden canvas/video
*/
import VideoProcess from "./VideoProcess";

const MediaProcess = ({ mediaStream, mediaStreams }) => {
  if (!mediaStream.editable) {
    return (
      <VideoProcess
        mediaStream={mediaStream}
        mediaStreams={mediaStreams}
      />
    );
  }
};

export default MediaProcess;
